<template>
  <validation-observer ref="formObserver">
    <b-form @submit.prevent="validationForm" class="form-container">
      <b-col>
        <h4 class="mb-2">Dane przedstawiciela</h4>

        <b-form-group label="Typ przedstawiciela" label-for="v-kind-select">
          <validation-provider name="Typ przedstawiciela" rules="required" v-slot="{ errors }">
            <v-select
              id="v-kind-select"
              label="value"
              :reduce="option => option.key"
              :clearable="false"
              placeholder="Wybierz typ przedstawiciela"
              v-model="form.kind"
              :options="kindOptions" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label="Imię" label-for="v-name">
          <validation-provider name="Imię" rules="required|min:2|max:36" v-slot="{ errors }">
            <b-form-input id="v-name" placeholder="Imię" v-model="form.name" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label="Nazwisko" label-for="v-surname">
          <validation-provider name="Nazwisko" rules="required|min:2|max:36" v-slot="{ errors }">
            <b-form-input id="v-surname" placeholder="Nazwisko" v-model="form.surname" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label="Nr telefonu" label-for="v-phone">
          <validation-provider name="Nr telefonu" rules="required|max:15|phone" v-slot="{ errors }">
            <b-form-input id="v-phone" placeholder="Nr telefonu" v-model="form.phone" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label="Email" label-for="v-email">
          <validation-provider name="Email" rules="required|email" v-slot="{ errors }">
            <b-form-input id="v-email" placeholder="Email" v-model="form.email" type="email" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group>
          <div class="d-flex align-items-center mb-1">
            <b-form-checkbox v-model="usePolishCounty" switch> Wybierz województwo polskie </b-form-checkbox>
          </div>
        </b-form-group>

        <b-form-group v-if="usePolishCounty" label="Województwo" label-for="v-county-select">
          <validation-provider name="Województwo" :rules="usePolishCounty ? 'required' : ''" v-slot="{ errors }">
            <v-select
              id="v-county-select"
              label="name"
              :clearable="false"
              placeholder="Wybierz województwo"
              v-model="form.county_id"
              :options="counties" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group v-else label="Region" label-for="v-region">
          <validation-provider name="Region" :rules="!usePolishCounty ? 'required|max:100' : ''" v-slot="{ errors }">
            <b-form-input id="v-region" placeholder="Np. Bayern, Deutschland" v-model="form.region" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- TODO: Removed for client tests -->
        <!-- <b-form-group label="Miasto" label-for="v-city">
          <validation-provider name="Miasto" rules="required" v-slot="{ errors }">
            <b-form-input id="v-city" placeholder="Miasto" v-model="form.city" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label="Kod pocztowy" label-for="v-postal_code">
          <validation-provider name="Kod pocztowy" rules="required|max:10" v-slot="{ errors }">
            <b-form-input id="v-postal_code" placeholder="Kod pocztowy" v-model="form.postal_code" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group> -->
      </b-col>

      <b-col class="mt-5">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary"> Zapisz </b-button>
      </b-col>
    </b-form>
  </validation-observer>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';
import { all } from '@/http/counties';
import { all as allCountiesEnum } from '@/constants/enums/counties';
import { all as allKindOptions } from '@/constants/enums/sale-representative-kind';

export default {
  mixins: [NotificationMixin],
  props: {
    saleRepresentative: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: this.saleRepresentative,
      counties: [],
      kindOptions: allKindOptions(),
      usePolishCounty: true,
    };
  },

  watch: {
    saleRepresentative(newValue) {
      if (!newValue) return;

      // Sprawdź czy ma ustawione województwo polskie czy region
      this.usePolishCounty = !!newValue.county_id;

      this.form = {
        ...newValue,
        county_id: newValue.county_id
          ? {
              id: newValue.county_id.id,
              name: allCountiesEnum().find((item) => item.key === newValue.county_id.name).value,
            }
          : null,
      };
    },
    usePolishCounty(newVal) {
      // Wyczyść przeciwne pole gdy przełączasz
      if (newVal) {
        this.form.region = null;
      } else {
        this.form.county_id = null;
      }
    },
  },

  async created() {
    try {
      const { data } = await all();

      this.counties = data.data.map((county) => {
        return {
          ...county,
          name: allCountiesEnum().find((item) => item.key === county.name).value,
        };
      });
    } catch (error) {
      this.showErrorNotification(
        'Problem z zapisaniem danych',
        'Wystąpił problem z pobraniem województw. Skontaktuj się ze swoim developerem.',
      );
    }
  },

  methods: {
    onSubmit() {
      const payload = {
        ...this.form,
        county_id: this.usePolishCounty && this.form.county_id ? this.form.county_id.id : null,
        region: !this.usePolishCounty ? this.form.region : null,
      };
      this.$emit('onSubmit', payload);
    },
    validationForm() {
      this.$refs.formObserver.validate().then((success) => {
        if (success) {
          return this.onSubmit();
        }

        this.showFormValidationNotification();
      });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
